module.exports = __webpack_public_path__ + "static/cf-reg-italic-3b8effe73b42e5403e87e09a18606a5c.eot";